import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { howSteps } from "@/mocks/home";

export default function HowItWorks() {
  return (
    <section id="how" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="玩法机制"
            title="黑料平台玩法与更新机制"
            description="一条线索从被发现到呈现给读者，会经过四个环节。理解这套流程，就知道平台内容为什么更新得这么快。"
          />
        </Reveal>

        <div className="relative mt-14">
          <span
            className="absolute left-0 right-0 top-6 hidden h-px bg-background-300 lg:block"
            aria-hidden
          />
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            {howSteps.map((step, index) => (
              <Reveal key={step.step} delay={index * 80}>
                <div className="relative flex flex-col">
                  <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-primary-200 bg-background-50 text-primary-600">
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <span className="mt-5 font-heading text-sm font-bold tracking-widest text-primary-500">
                    STEP {step.step}
                  </span>
                  <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={120}>
          <div className="mt-14 flex flex-col gap-5 rounded-lg border border-background-200 bg-background-100/60 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div className="flex items-start gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-timer-flash-line text-xl" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  更新机制：热度高的话题，走更快的通道
                </h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                  讨论量持续攀升的话题会进入加速队列，核实通过后优先上推荐位；普通内容则按常规节奏处理，保证展示区域不被低质内容占满。
                </p>
              </div>
            </div>
            <a
              href="#flash"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看快讯流
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}